const common = {
    //判断是否微信
    isWeiXin(){
        if(/MicroMessenger/gi.test(navigator.userAgent)) {
            return true;
        }else {
            return false;
        }
    },
    //判断是不是IOS
    isAndroid_ios(){  
        try {
            let u = navigator.userAgent, app = navigator.appVersion;  
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器  
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端  
            console.log(navigator.userAgent)
            console.log(`isAndroid:${isAndroid}`)
            console.log(`isiOS:${isiOS}`)
            return !isAndroid  
        } catch (error) {
            console.log(error)
        }

        // var ua = navigator.userAgent.toLowerCase();
        // if( ua.index0f("iphone") > -1 || ua.index0f("ipad") > -1 ){ 
        //     return true
        // }else {
        //     return false
        // }



    },
    /** 需改ISO 图片 */
    _modifyImage() {
        if( this.isAndroid_ios() ) {
            document.getElementById("imageId").src = './image/ios-icon.png'
        }
    },
    /** showToast */
    showToast(data = {}) {
        if( document.getElementById("toast") ) {
            return
        }
        if( document.getElementById('loading') ) {
            document.getElementById('loading').parentNode.removeChild(document.getElementById('loading'))
        }
        const el = document.createElement('div');
        el.innerHTML = data.title;
        el.setAttribute('id','toast');
        document.getElementsByTagName('body')[0].appendChild(el)
        const time = setTimeout(function(){
            const div = document.getElementById("toast");
            div.parentNode.removeChild(div);
        },data.duration || 2000)
    },
    /** url 参数 */
    query: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || '';
    },
    /**获取用户信息 */
    _getUserInfo(url,data){
        return axios({
            method: 'post',
            url,
            data:Qs.stringify(data,{indices: false})
        })
    },
    /** 下载app */
    _getApp() {
        if( this.isWeiXin() ) {
            document.getElementById('guide').style.display = 'block';
        }else {
            window.location.href = "https://agent-res.wlyinfo.com/apk/maodouyangche.apk";
        }
    },
    /** 复制 */
    copyTextToClipboard(text) {
        var textArea = document.createElement("textarea")
        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.left = 0
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = 0
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        try {
            var msg = document.execCommand('copy') ? '成功' : '失败'
            common.showToast({
                title:'复制成功!'
            })
        } catch (err) {
            common.showToast({
                title:'请手动选文本复制!'
            })
        }

        document.body.removeChild(textArea)
    },
    /** loading */
    _getLoading(options) {
        if( !options.show && document.getElementById('loading') ) {
            document.getElementById('loading').parentNode.removeChild(document.getElementById('loading'))
            return
        }
        const el = document.createElement('div');
        el.setAttribute('id','loading');
        const html = '<div class="lx-load-box">'+
                        '<div class="lx-loading">'+
                            '<div class="loading_leaf loading_leaf_0"></div>'+
                            '<div class="loading_leaf loading_leaf_1"></div>'+
                            '<div class="loading_leaf loading_leaf_2"></div>'+
                            '<div class="loading_leaf loading_leaf_3"></div>'+
                            '<div class="loading_leaf loading_leaf_4"></div>'+
                            '<div class="loading_leaf loading_leaf_5"></div>'+
                            '<div class="loading_leaf loading_leaf_6"></div>'+
                            '<div class="loading_leaf loading_leaf_7"></div>'+
                            '<div class="loading_leaf loading_leaf_8"></div>'+
                            '<div class="loading_leaf loading_leaf_9"></div>'+
                            '<div class="loading_leaf loading_leaf_10"></div>'+
                            '<div class="loading_leaf loading_leaf_11"></div>'+
                        '</div>'+
                        '<div class="lx-load-content">' + (options.loading || '加载中...') +'</div>'+
                    '</div>'
        el.innerHTML = html;
        document.body.appendChild(el);
    }
};

export default common
